import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FolderCard } from './FolderCard';
import { FolderModal } from './FolderModal';
import { PORTFOLIO_FOLDERS } from './portfolioData';

export const Portfolio = () => {
  const { t } = useTranslation();
  const [openFolder, setOpenFolder] = useState(null);

  return (
    <section id="portfolio" className="relative border-b border-ink pt-16 md:pt-24 pb-24 md:pb-32" data-testid="portfolio-section">
      <div className="max-w-[1400px] mx-auto px-5 md:px-8">
        {/* Eyebrow */}
        <div className="flex items-center gap-3 mb-8">
          <span className="font-mono text-xs bg-ink text-page px-2 py-1 tracking-widest2">§ 01</span>
          <span className="font-mono uppercase text-xs tracking-widest2 text-ink">{t('portfolio.overline')}</span>
        </div>

        {/* Headline */}
        <div className="grid grid-cols-12 gap-8 md:gap-12 mb-14 md:mb-20">
          <div className="col-span-12 lg:col-span-7">
            <h1 className="display text-6xl md:text-7xl lg:text-8xl leading-[0.9] text-ink">
              {t('portfolio.heading_pre').trim()}<br />
              <span className="serif-italic">{t('portfolio.heading_italic')}</span>
              {t('portfolio.heading_post')}
            </h1>
          </div>
          <div className="col-span-12 lg:col-span-5 lg:pt-6">
            <p className="serif-italic text-lg md:text-xl leading-snug text-ink/85">{t('portfolio.subhead')}</p>
          </div>
        </div>

        {/* Folder grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 md:gap-x-8 gap-y-14 md:gap-y-16">
          {PORTFOLIO_FOLDERS.map((folder, i) => (
            <FolderCard key={folder.id} folder={folder} index={i} onOpen={setOpenFolder} />
          ))}
        </div>

        {/* Footer note */}
        <p className="mt-20 md:mt-24 serif-italic text-base md:text-lg text-ink/70 text-center max-w-2xl mx-auto">
          {t('portfolio.footerNote')}
        </p>
      </div>

      <FolderModal folder={openFolder} onClose={() => setOpenFolder(null)} />
    </section>
  );
};
